import React from "react";

export const Unsplash = props => {
  return <p className="unsplash">Photo by Alexander Andrews on Unsplash</p>;
};

export default Unsplash;
